import React from 'react';

import { useSelector } from 'react-redux';

import dynamic from 'next/dynamic';

import { useFeatures } from '@atc/features';

import srpResultsDuck from '@/ducks/srp/srpResultsDuck.js';
import srpSimilarListingsDuck from '@/ducks/srp/srpSimilarListingsDuck.js';
import srpSupplementalDuck from '@/ducks/srp/srpSupplementalDuck.js';

import useCustomContent from '@/hooks/useCustomContent';

import { DynamicPlaceholder } from '@/components/DynamicPlaceholder/DynamicPlaceholder';
import LazyComponent from '@/components/LazyComponent';

const heights = { xs: 326, sm: 318, md: 198, lg: 206 };
const AlternativeSearchAction = dynamic(() => import(
    /* webpackChunkName: "AlternativeSearchAction" */
    '@/components/AlternativeSearchAction'
), {
    ssr: false,
    loading: () => (
        <DynamicPlaceholder height={heights} />
    ),
});

function SRPAlternativeSearchActionContainer() {
    const {
        srp_bottom_lazy_threshold: [, { defaultThreshold }],
    } = useFeatures([
        'srp_bottom_lazy_threshold',
    ]);

    const isSimilarLoading = useSelector(srpSimilarListingsDuck.selectors.getResultLoading);
    const listingResultCount = useSelector(srpResultsDuck.selectors.getResultsCount);
    const supplementalResultCount = useSelector(srpSupplementalDuck.selectors.getResultCount);
    const { isEnableCustomContent } = useCustomContent();

    const enableAlternativeSearchAction = (supplementalResultCount + listingResultCount <= 25) || listingResultCount === 0;

    return enableAlternativeSearchAction && !isSimilarLoading && (
        <LazyComponent
            height={heights}
            threshold={defaultThreshold}
        >
            <AlternativeSearchAction withCustomContent={isEnableCustomContent} />
        </LazyComponent>
    );
}

export default React.memo(SRPAlternativeSearchActionContainer);
